import { useQuery, useSubscription } from "@apollo/react-hooks";
import { MY_NEWS_GET_ADMIN_LIST, MY_NEWS_SUBSCRIPTION } from "my-news/graphql";

export const useMyNewsAdminList = () => {
  const { data, loading, error, fetchMore, refetch } = useQuery(
    MY_NEWS_GET_ADMIN_LIST,
    {
      fetchPolicy: "cache-and-network",
      variables: { page: 1, pageSize: 4 },
    },
  );

  useSubscription(MY_NEWS_SUBSCRIPTION, {
    onData: () => {
      refetch();
    },
  });

  const handleFetchMore = (pageSize: number) => {
    fetchMore({
      variables: {
        page: 1,
        pageSize,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        const prevData = prev.getMyNewsAdminList;
        const newData = fetchMoreResult.getMyNewsAdminList;
        const rows = newData.rows;
        const pageSize = newData.pageSize;
        const updatedData = {
          ...prevData,
          rows,
          pageSize,
        };
        const updatedResult = {
          getMyNewsAdminList: updatedData,
        };
        return updatedResult;
      },
    });
  };

  return {
    data: data?.getMyNewsAdminList || null,
    loading,
    error,
    handleFetchMore,
  };
};

export default useMyNewsAdminList;
